import Vue from 'vue'
import VueRouter from 'vue-router'
import VueMeta from 'vue-meta';

Vue.use(VueRouter)
Vue.use(VueMeta)

const routes = [
  {
    path: '',
    component: () => import('../views/CheckUpEnergetico.vue'),
    children: [
      {
        path: '/',
        name: 'step-1',
        component: () => import('@/views/steps/Step-1.vue'),
      },
      {
        path: '/consumi',
        name: 'step-2',
        component: () => import('@/views/steps/Step-2.vue'),
      },
      {
        path: '/caldaia',
        name: 'step-3',
        component: () => import('@/views/steps/Step-3.vue'),
      },
      {
        path: '/cucina-e-condizionatore',
        name: 'step-4',
        component: () => import('@/views/steps/Step-4.vue'),
      },
      {
        path: '/energie-alternative',
        name: 'step-5',
        component: () => import('@/views/steps/Step-5.vue'),
      },
      {
        path: '/gia-cliente',
        name: 'step-6',
        component: () => import('@/views/steps/Step-6.vue'),
      },
      {
        path: '/ricevi-resoconto',
        name: 'step-7',
        component: () => import('@/views/steps/Step-7.vue'),
      },
      {
        path: '/spesa-prevista',
        name: 'results',
        component: () => import('@/views/steps/Results.vue'),
      },
    ]
  },
  {
    path: '/email-sent',
    name: 'message-sent',
    component: () => import('../views/MessageSent.vue'),
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  routes
})

export default router
